<template>
<transition name="fade">
  <div v-if="!state.loading">
    
    
    <div class="card mb-5 mb-xxl-8 mt-5" >
        <div class="card-body pt-9 pb-0">

          <div class="d-flex flex-nowrap flex-lg-nowrap mb-3">

            <div class="me-7 mb-4">

              <div class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                <img :src="'data:image/png;base64,' +state.infoDatas.emp_photo_64" alt="profile" :style="`object-fit: cover; opacity: ${ state.loading ? 0 : 1 };`" />
                <label
                      v-if="!state.loading"
                      class="d-none d-md-block btn btn-icon btn-circle btn-active-color-primary w-35px h-35px bg-white shadow "
                      data-kt-image-input-action="change"
                      style="position: absolute; right: -17px; bottom: -17px;"
                    >
                      <i class="bi bi-pencil-fill fs-6"></i>
                      <input type="file" name="avatar" accept=".png, .jpg, .jpeg" class="d-none"/>
                      <input type="hidden" name="avatar_remove" />
                    </label>
              </div>

            </div>

            <div class="flex-grow-1">
              <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                <div class="d-flex flex-column">
                  <div class="d-flex align-items-center mb-2">
                    <a
                      class="text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
                        v-if="state.infoDatas.emp_nomprenom">
                        {{state.infoDatas.emp_nomprenom}}
                    </a>
                    <a  v-if="!state.loading">
                      <span class="svg-icon svg-icon-1 svg-icon-primary">
                        <inline-svg src="media/icons/duotune/general/gen026.svg" />
                      </span>
                    </a>
                  </div>

                  <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                    <a class=" d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" v-if="state.infoDatas.emp_fonction">
                      <span class="svg-icon svg-icon-4 me-1">
                        <inline-svg src="media/icons/duotune/communication/com006.svg" />
                      </span>
                      {{state.infoDatas.emp_fonction}}
                    </a>
                    <a class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2" v-if="state.infoDatas.emp_localisation">
                      <span class="svg-icon svg-icon-4 me-1">
                        <inline-svg src="media/icons/duotune/general/gen018.svg" />
                      </span>
                      {{state.infoDatas.emp_localisation}}
                    </a>
                    <a class=" d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2 " v-if="state.infoDatas.emp_mail_pro" >
                      <span class="svg-icon svg-icon-4 me-1">
                        <inline-svg src="media/icons/duotune/communication/com011.svg" />
                      </span>
                      {{state.infoDatas.emp_mail_pro}}
                    </a>
                    <a class="d-flex align-items-center text-gray-400 text-hover-primary mb-2 " v-if="state.infoDatas.emp_tel" >
                      <span class="svg-icon svg-icon-4 me-1">
                        <i class="bi bi-telephone fs-4"></i>
                      </span>
                      {{state.infoDatas.emp_tel}}
                    </a>
                  </div>
                </div>
              </div>
            
              <div v-if="state.infoDatas.emp_x_am == 1" class="d-flex flex-wrap flex-stack d-none d-md-flex">
                <div class="d-flex flex-column flex-grow-1 pe-8">
                  <div class="d-flex flex-wrap">
                    <div class=" border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" >
                      <div class="d-flex align-items-center">
                        <div class="fs-2 fw-bolder">
                          {{ state.infoDatas.projets }}
                        </div>
                      </div>
                      <div class="fw-bold fs-6 text-gray-400">Projet(s)</div>
                    </div>

                    <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                      <div class="d-flex align-items-center">
                        <div class="fs-2 fw-bolder" data-kt-countup="true" data-kt-countup-value="60" data-kt-countup-prefix="%" >
                          {{ millier(state.infoDatas.marge) }} €
                        </div>
                      </div>

                      <div class="fw-bold fs-6 text-gray-400">Marge mensuelle réalisée</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center w-200px w-sm-300px flex-column mt-3 ">
                  
                  <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                    <span class="fw-bold fs-6 text-gray-400">Objectifs Mensuels</span>
                    <span class="fw-bolder fs-6">{{ state.infoDatas.objectifs }} %</span>
                  </div>

                  <div class="h-5px mx-3 w-100 bg-light mb-3">
                    <div class="bg-success rounded h-5px" role="progressbar" :style="`width: ${objoMensuel()}`" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    <div :class="{'d-none': !state.generalPage}">
      <div class="shadow bg-white d-flex align-items-center rounded p-5 mb-7 h-100px bg-hover-light-primary d-md-none" @click="goto('list_n2f')">
        <span :class="`svg-icon-success`" class="svg-icon ms-5 me-8">
          <span class="svg-icon svg-icon-1">
            <i class="fs-3tx bi bi-credit-card text-primary"></i>
          </span>
        </span>
        <div class="flex-grow-1 me-2">
          <span class="fw-bolder text-gray-800 text-hover-primary fs-2">NOTES DE FRAIS</span>
          <span class="text-muted fw-bold d-block">Gestion de vos dépenses</span>
        </div>
        <span class="fw-bolder py-1 text-primary me-3"><u>Afficher</u></span>
      </div>
      
      <div class="shadow bg-white d-flex align-items-center rounded p-5 mb-7 h-100px bg-hover-light-primary  d-md-none" @click="goto('indispos')">
        <span :class="`svg-icon-success`" class="svg-icon ms-5 me-8">
          <span class="svg-icon svg-icon-1">
            <i class="fs-3tx bi bi-calendar-check text-primary"></i>
          </span>
        </span>
        <div class="flex-grow-1 me-2">
          <span class="fw-bolder text-gray-800 text-hover-primary fs-2 text-uppercase">Indisponibilités</span>
          <span class="text-muted fw-bold d-block">Gestion de vos congès et RTT</span>
        </div>
        <span class="fw-bolder py-1 text-primary me-3"><u>Afficher</u></span>
      </div>

      <div class="shadow bg-white d-flex align-items-center rounded p-5 mb-7 h-100px bg-hover-light-primary d-md-none" @click="goto('documents')">
        <span :class="`svg-icon-success`" class="svg-icon ms-5 me-8">
          <span class="svg-icon svg-icon-1">
            <i class="fs-3tx bi bi-file-earmark-pdf text-primary"></i>
          </span>
        </span>
        <div class="flex-grow-1 me-2">
          <span class="fw-bolder text-gray-800 text-hover-primary fs-2 text-uppercase">Documents</span>
          <span class="text-muted fw-bold d-block">Accèder à votre GED</span>
        </div>
        <span class="fw-bolder py-1 text-primary me-3"><u>Afficher</u></span>
      </div>

      <div class="shadow bg-white d-flex align-items-center rounded p-5 mb-7 h-100px bg-hover-light-primary d-md-none" @click="goto('commissions')">
        <span :class="`svg-icon-success`" class="svg-icon ms-5 me-8">
          <span class="svg-icon svg-icon-1">
            <i class="fs-3tx bi bi-bag-plus text-primary"></i>
          </span>
        </span>
        <div class="flex-grow-1 me-2">
          <span class="fw-bolder text-gray-800 text-hover-primary fs-2 text-uppercase">Commissions</span>
          <span class="text-muted fw-bold d-block">Liste des factures commissionées</span>
        </div>
        <span class="fw-bolder py-1 text-primary me-3"><u>Afficher</u></span>
      </div>

      <div class="shadow bg-white d-flex align-items-center rounded p-5 mb-7 h-100px bg-hover-light-primary d-md-none" @click="goto('me')">
        <span :class="`svg-icon-success`" class="svg-icon ms-5 me-8">
          <span class="svg-icon svg-icon-1">
            <i class="fs-3tx bi bi-person-exclamation text-primary"></i>
          </span>
        </span>
        <div class="flex-grow-1 me-2">
          <span class="fw-bolder text-gray-800 text-hover-primary fs-2 text-uppercase">profil</span>
          <span class="text-muted fw-bold d-block">Diverses informations vous concernant</span>
        </div>
        <span class="fw-bolder py-1 text-primary me-3"><u>Afficher</u></span>
      </div>
    </div>


    <div class="d-md-block" :class="{'d-none': state.generalPage}">
      <el-container>
        <el-aside width="300px" class="card-aside d-none d-md-block">
              <ul class="nav nav-tabs nav-pills flex-row border-0 flex-md-column mb-3 mb-md-0 fs-6 w-100%" >
                  <li class="nav-item w-100 me-0 mb-1" v-for="item, index in tabs" :key="index">
                      <a class="nav-link w-100 btn btn-flex btn-active-light-primary btn-sm"  :class="{ 'active': state.lienMenu == item.value }"  
                        data-bs-toggle="tab" @click="state.lienMenu = item.value; cancelModifs()" style="padding: 20px 0 20px 18px;">
                        <i class="fs-3 me-2 text-primary" :class="item.icon"></i>
                          <span class="d-flex flex-column align-items-start">
                              <span class="fs-5 fw-bold">{{ item.title}}</span>
                          </span>
                      </a>
                  </li>
              </ul>
        </el-aside>
        <el-main class="ms-0 ms-md-6">
          <div> <!-- class="card shadow-none" -->
            <div class="card-header">

              <div class="card-title m-0 w-100">
                <el-select v-model="state.lienMenu" class="fw-bolder d-block d-md-none" style="width: 100%;" placeholder="Selectionner" size="large">
                  <el-option class="fw-bolder" v-for="item in tabs" :key="item.title" :label="item.title"  :value="item.value" />
                </el-select>
                <div class="d-flex justify-content-md-between justify-content-end align-items-center mb-2 mt-3 mt-md-0">
                  <h5 class="fw-bolder d-none d-md-block">{{ tabs[state.lienMenu].title }}</h5>
                  <div class="d-flex gap-3">
                    <button v-if="(!state.editData && !state.addAdresseObjo) && (state.lienMenu != 4 || state.permission)" class="btn btn-sm btn-primary" @click="state.editData = true">Modifier</button>
                    <button v-if="(state.lienMenu == 3 || (state.lienMenu == 4 && state.permission)) && !state.editData && !state.addAdresseObjo" class="btn btn-sm btn-success" @click="state.addAdresseObjo = true">Ajouter</button>
                  </div>
                  <div v-if="state.editData || state.addAdresseObjo" class="d-flex justify-content-end gap-3">
                    <el-popconfirm title="Annuler les modifications ?" @confirm="cancelModifs" :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                      <template #reference>
                        <div class="btn btn-sm btn-outline-danger text-hover-white">Annuler</div>
                      </template>
                    </el-popconfirm>
                    <el-popconfirm title="Modifier les données saisies ?" @confirm="updateData" :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                      <template #reference>
                        <div class="btn btn-sm btn-success text-hover-white">Confirmer</div>
                      </template>
                    </el-popconfirm>
                  </div>
                </div>
              </div>

              <router-link
                to="/account/settings"
                class="btn btn-primary align-self-center d-none"
                >Edit Profile</router-link
              >

            </div>
            <div class="card-body">
              <GeneralinfosVue :datas="state.infoDatas" :permission="state.permission" v-if="state.lienMenu == 0" :key="state.renderInfos" :editData="state.editData" @setNewData="setNewData"/>
              <ContactInfosVue :datas="state.infoDatas" :permission="state.permission" v-if="state.lienMenu == 1" :key="state.renderInfos" :editData="state.editData" @setNewData="setNewData"/>
              <BancairesRefsVue :datas="state.infoDatas" :permission="state.permission" v-if="state.lienMenu == 2" :key="state.renderInfos" :editData="state.editData" @setNewData="setNewData"/>
              <AdressesVue :datas="state.userAdresses" :permission="state.permission" v-if="state.lienMenu == 3" :key="state.renderInfos" :editData="state.editData" :addAdresse="state.addAdresseObjo" @setNewAdresse="setNewAdresse" @setNewData="setNewDataAdr"/>
              <ObjectifsVue :datas="state.objectifs" :permission="state.permission" v-if="state.lienMenu == 4" :key="state.renderInfos" :editData="state.editData" :addObjo="state.addAdresseObjo" @setNewObjo="setNewObjo" @setNewData="setNewDataObjo"/>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    </div>
  </transition>
</template>

<script lang="ts">
import mAxiosApi from "@/api";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { defineComponent, onMounted, onUpdated, reactive} from "vue";
import AdressesVue from "./Adresses.vue";
import BancairesRefsVue from "./BancairesRefs.vue";
import ContactInfosVue from "./ContactInfos.vue";
import GeneralinfosVue from "./Generalinfos.vue";
import ObjectifsVue from "./Objectifs.vue";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus";




export default defineComponent({
  name: "General",
  components: {
    GeneralinfosVue,
    BancairesRefsVue,
    ContactInfosVue,
    AdressesVue,
    ObjectifsVue
  },
  setup() {
    setCurrentPageBreadcrumbs("Général", ["Pages", "Profile"]);

    const router = useRouter();

    const state = reactive({
      lienMenu: 0,
      infoDatas: {} as any,
      userAdresses: [] as any,
      objectifs: [] as any,
      loading : true,
      generalPage: true,
      permission: false,
      editData: false,
      addAdresseObjo: false,
      newData: [] as any,
      newDataAdr: [] as any,
      newDataObjo: [] as any,
      newAdresse: {} as any,
      newObjo: {} as any,
      renderInfos: 0,
    });

    const goto = (path) => {
      router.push({ name: path });
    }


    const tabs = [
      {title:"Informations générales", icon: "bi bi-person-vcard", value: 0},
      {title:"Information de contact", icon: "bi bi-postcard", value: 1},
      {title:"Références bancaires", icon: "bi bi-credit-card", value: 2},
      {title:"Adresses", icon: "bi bi-geo-alt", value: 3},
      // {title:"Mutuelle", icon: "bi bi-postcard-heart", value: 4}, ATTENTION A LA VALUE
      {title:"Objectifs", icon: "bi bi-graph-up-arrow", value: 4},
    ]

    const objoMensuel : any = () => {
      if(state.infoDatas && state.infoDatas.objectifs) {
        if(state.infoDatas.objectifs > 100) {
          return "100%";
        }else {
          return state.infoDatas.objectifs + "%";
        }
      }
    };

    const millier = (nombre)  => {
      return new Intl.NumberFormat().format(nombre);
    };

    const checkRoot = () => {
      if (router.currentRoute.value.name == "me") {
        state.generalPage = false;
      }else{
        state.generalPage = true;
      }
    }
    
    onUpdated(() => {
      setTimeout(() => {
        checkRoot();
      }, 100);
    })

    const reloadData = async () => {
      const userInfos = await mAxiosApi.prototype.getAxios("/getUserInfos");
      const userAdresses = await mAxiosApi.prototype.getAxios("/getAdresses");
      const objectifs = await mAxiosApi.prototype.getAxios("/getUserObjectifs");
      state.infoDatas = userInfos.results;
      state.userAdresses = userAdresses.results;
      state.objectifs = objectifs.results;

      if(state.infoDatas.objectifs == null) state.infoDatas.objectifs = 0;
      if (!state.infoDatas.emp_photo_64) {
       if (state.infoDatas.emp_civilite == 0 ) {
        state.infoDatas.emp_photo_64 = "/9j/2wBDAAUDBAQEAwUEBAQFBQUGBwwIBwcHBw8LCwkMEQ8SEhEPERETFhwXExQaFRERGCEYGh0dHx8fExciJCIeJBweHx7/2wBDAQUFBQcGBw4ICA4eFBEUHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh7/wAARCACwALADASIAAhEBAxEB/8QAHQABAAICAwEBAAAAAAAAAAAAAAUHBAYBAggDCf/EAEQQAAEDAwIDBQQHBAYLAAAAAAEAAgMEBREGIQcSMRNBUWFxCCKBkRQyQnKhscEVI1KCNGJjosLRFiQzNVNzg5Kz0vD/xAAbAQEAAQUBAAAAAAAAAAAAAAAABAIDBQYHAf/EACsRAAICAgECBQMEAwAAAAAAAAABAgMEEQUSMRMhQVFxFGGRFSIjMzJiwf/aAAwDAQACEQMRAD8A3tERbcYQIiIAiIgCIiAIiIAiLnB8D8k2NHCIiAIiIAiIgCIiAIiIAiIgCIiAIiIAiIgOlRNFTwPnnkZFFG0ue95w1oHUkqr9T8U3iV1Pp+mZyDb6VOCeb7rNtvMn4LM443WSnt1DaInloqnulmAH1mMwAPTmcD/KqjK1Lm+YtqtdNL1ruzPcbx8Jw8Sxb9icuGrdS1ziZ75WgE/VieIgP+0BYkV9vcT+eO83JrvH6U8/mcKORay8u6T25P8AJmlTWlpRRuVk4kakt7mirmjucI6snbyv+D2j8wVaeltWWfUNPz0s3YztH7ynmID2+nc4eYXnpCGnBLWnHTIWTw+dyMd6k+pfch5HG03dlpnp6Gpp5pXxQzxSSRgF7WOBLc9M4X2wqw4CR4gvEoa0ZliZsMDOCf1VoLdcLJeTSrWtbNayqVTa4J70dURFLLAREQBERAEREAREQBERAFC64vLrDpiruMQaZ2gMhDhkc7jgZ8hnPwU0q946yubp+3QgkNlrcu8+Vjj+f5KHyFzpxpzj30ScOpW3Ri+xT1dJV1lXJVz1tRNUPJLnzSuk5iTvsenoMBdYy/IY9h5j0xvldlzk5Dg4tI8FzGdkrHuXc3NRS8kMEjI3HkuFcnCnQVBrfSlRc9RQOZJ9IMdHW0z+yne1oAd2gHuvw4YBcM7Hr1OVc+ATj/uvVRA8K2iDz843N/JeJF1VSKRTOxPcOquCHgDejI3ttVWprO/lt8hP/kW46d4J6Tt1PJ+0nz3qpexzQ+pAayLI6sY3AyOoc7JHcVVqPqz1UyNb4J0kcGjG1TTl9XUSSP8A5TyD8Gj5reCtb4Z0E1s0lT0VQeaSGadjj44leM/HC2TK6bx0VHFrS9kaNmPeRPfudURFMIwREQBERAEREAREQBERAFX/AB0gL9NUFQBtDWjPlzMcFYCgeIVtfdtG3CkiaXzNYJomjqXMPMB8cY+Kh8hU7cacV7EnDs8O+Mn7nnpF3jjfLI1kLHSPeQGNYMucT0AA3JWXdrNdrNGyW72qso2SAljpYyA7Azsemcb46rl+mno3U9M8CJ4JuFdmEBH7pskUn32yODvx3W7rV+FVkhsGg7VRxsAllgbUVDs/XleA5x/T0C2hCdHsgiIvF3Kn2NIljZDPNFHjlbK/HxcT+ZXzWZdoTBc6hmNi8uHx3WGurYrjKmLj20jm2RFq2Sl32wiIr5aCIiAIiIAiIgCIiAIiIAuQuEXoK70zYqbTXGygfUMYLfXNl+hOeNmSkA8n3h7wHk4K1eImn36o0TebA1kb6uoo3mkMpwGzgZY7Pdg46LXdR2elvtrfQVXMz3g+KZhw+GQbte09xBWXwmuep5Ku6WDVUjamWhjjfSVYj5e3icXAnI2JBA7gRkZz1Ohczxksa3xoL9rNw4jOjfDwZ/5G822N0NtpInt5XxwMa5vgQ0AhZCeaLX35md0ERFSems6mx+1P+m3P4qKUhf3812m8sD8FHrqPGx6cStfZHPM97yZ/LCIimkQIiIAiIgCIiAIiIAiIgCIiALNsckkNbzxkfUOR49FhKY0/bKqognrYo8wxkMcSepO5+WyxvLy1h2fBP4vX1cN+5NwVcUuziGP9eqyVFOoZwC5oa4DuHVdY5KmDpzgeBGQuYdbXc6G4p9iWRRrrlUCCQw0EtZUBhMcEBaHyuA2Y3mIGT0GSB5qj9V+0HXPp5KSwablttTl0b5bk8GSFwOCOybn3gcghzhg9QeinYmJblP8AjXYh5WVXjL+RnN04x21uqbhS1doqhBFWzQNqIZGu2Y8s5i04PVp6ZW6aevtpv9Eau01sdVE08r+XZzHYzhzTu0+RC8rHJJc5xc4klzj1JO5J8yd1K6U1HV6VvcV4pnvMTCG1cQO00OfeaR3kZJb4EeBK6HRa64qD7I0O5eJNyXqepkXSnmiqKeOoheHxSsD2OHRzSMg/Jd1kCKEREAREQBERAEREAREXoCLV9d63tOk6cCfNVXSDMVJE4cx83H7LfM/AFUtqbiDqe/c7Ja40NK7I+jUZLBjzf9Z3zA8lZstjDyK4wbWy7tTa209YHOhq69ktUBtS0/7yU+GQNm58XEBXpoGe112irXXWiTt6GtpmzskI3fzjJyO45yCO7GF+e9JhtRGGgD3idh346r0B7MPEiOwXT/Qy9VDY7XcZua3zPOG09S47xk9zZDuM/bJGffAGPy5Suh5EildEj0PdLU6ImWlBdH1Le9qive8QVure8HqOqj6+009STIwdlL4t6H1C1DK4zb6qvwbNh8p0rpt/JA2ljP2lT+40Hn8PJVP7VnDSlqad+ubXTthnaWtunZt+uOjZiPEbNcfDB+yrkgoZ6Kvhln5BC1+8hcA0evgp2vpKa4UE9FWRNmpamJ0UrCMhzHDB/AqXxCnQn1LXmRuXkrpKUHtaPzdqIZIZnRSNLXtOCF8Kj+jyeTcreOIGnJrRfblZJMvqrbUPha49ZGDdufMsLXepWjz708mP4StlnHTMBFnoXgVcDX8N6Bjzl1E99JjO4ax3uf3S1byqk9maZ7rBeadx2ZWRvaPWJo/NqttZCl7gixNakERFcKQiIgCIiAIi6yyRxRmSV7WMb1c44AXoOyr7jRrWbTNsht1re1t0rgS2TGTTxDYvA6cxOzc+ZwcYU5cdUsa8xW+HtP7STYZ8h/nheeteXae+asr66pl7Q84hYcAAMZkADHnzH4q1kOVcPkqqSnP4IUvc+Z00kkkkjzzPe9xc558XE7k+ZX0a/PVfFdmndY3ZLaM2k3qY/ifwUhMztIXxhxaXDAcOrT4jzUdQFprGDO/I4j5hSeVch2LU+57k4UapGpdHWe4TOAnqqVh3O5eBh49Q4EFblkLzj7JN1bdrPetHTS9nU0UouduPTDJNpWDvOJG8x8O0CvOK5VJYKF8bo68uEYJG2/2vBYu2PRNomQfUitPaEuVyknobUaZzLNIO0ErhllTM0/UP3cZwevUfVXHAEXyorLqIbjVChpoYwyKV5fCZXE7AHduGgbDA3GysriXBTxcN70ySJkkdPb5HMDxnDmtyHeoO+VqPs2zdpp68QEY7KvHxBiYViHW1lpt9zeasqFnATrVa/a0t/L7/ACUr7R8b2cU6iV8AhlloaeSZg39/3282e/Ia35KkdT0/0adz2DEU7XEY7nDcj9VevtMSdrxjuO+RFQ0sXpgOd/jVJatmbI6OmGD2TXSuPhkFo/X5La1/SmznL/taRY/syO/1O+N/rwH+6Vcao3gFXutFDcJ5qdz4Kl7GhwPvAsByQO8bhXVQ1tNWw9rTyh7e/uI9R3KdRF+GnoszkuoyERFcPAiIgCIiA4e5rGlzjhoGSVoF+ustyqSSS2naf3cfl4nxK3usiM9JNE04L43NHxCrSVj43uje0tc0kEHuIUnHSbbZZubOj38kckn8LS78MqjS4vcZHHd5Lj6k5V31X9Em/wCW78iqOi3gjIIOWA5Bz3KJyb84l3CXc5RN+8IsSTj6U0jop46hredrC5j2j+FTMUkcrA+N4c094UHREOErT/Hn5rIaDG/tIX8ju8fZd6j/AOKrjLRS1ssfgxqU6R4nWK9Pfy0v0kUlXn/gTEMd8A7kcfuL3W+nhfUR1LowZWAhr/Ir826aaOsglgljc08vLI0nYhwI2PoveXAXVDtXcK7Nc6iQSV0MX0OtPjNF7jnfzYDh5OUfLjtKSLtD15GfxgPLwx1Fv9ahkb8xj9VpHs3SgNv0A73wy49Q5v8AhW48Z38vDS85+3G1nze0KvPZvlcNSXuLflko4HD1D3/+y162fTlwN64+rq4C9/7L/hUXtAVzBxZ1XPKf3dPUMYfRsEWfzKpyGlqrrWGnjGamree/6hP6AfkrZ4oiS5cT9UPgidNz3SZuw2IaQzr0+yo3SWnIbKySWRwkqJC4AgbRsJyGj4YyfJbrTjStUF6aOb2WqEpP1Ja10MFttsNDTj93E0NBPU+J+O5+Kz6KqnopxPTyFrx8iPA+K+WV1WbjFJa9DH7beyyLVVsrqGOpYMB2xHgR1CylE6Sgkp7KztWlrpXukDT3A9FLKBNJSeiXFvQREVBWEREAUNfrDFcC6ohcIqnvJ+q/18/NTKKqMnF7RTJbK3r6Cro3ctTAW52yRkFa9c9MWWvc58tGyOQ9ZIjyE+uNj8Vc8sbJWFkjGvaeocMgqHrtM22fLoQ+nd/UO3yKvucJrU0W+iUfOLKOreH4BJpLmAO5s8efxbj8lD1GiL9Hkxx004/s5sH8QFeVRpOrZk09RFIPB2Wn/JYM9iu0PWiMgHfGQ5WXh48vsVq61dyiodM6hgqH9pZqns3DdwLXD8HL6vtF1YcOttX8IXH9FcslHVx/7SmmZ6sK+Ra9vUEeowqXx1fpIq+pl7FTWyhuP0YRvt1Y2RpIdmBwyfEHHRX97KWqRpWuvdq1DKaC11kbKuCWZpDRO3DHN/mZyYAH2CtZy5Mu8VTLjoSj0uR6sqSe0i6eLHEPTN60nVWa1VdRUzzSRnnbAWsAa9rju7HcCqqsGo7rYKmeos9SaSWeLsXyBoc4NznbIwDt1wVHMgqZD7lPM/7sZKyobLdZhllDNj+sOX81RXw+HCasa217kz9bzljPFjLUH5tIwpZHSzyzSOc+SWR0j3OO7nOJJJ8SSSV1yFO02lrjI4ds6GFv3uY/gpaj0rRR4NTNJOfAe6Pw3WS8SEFpGH6JN7Zp8Eck8gjhjfI89zWkraLJprlcJ7kASDlsIOR/Mf0WxU1NT0rOzpoWRN8GjC+qszvbWkXY1a82PNERWS6ERFSVBERAEREAREQBERAc5PiuDv1APwRF6Bhv8LfkmG/wt+SImwcgkdCQuPXf1REAREXgCIiAIiIAiIgP/9k=";
       }else {
        state.infoDatas.emp_photo_64 = "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";
       }
      }
    }

    const setNewData = (newData) => {
      state.newData = newData
    }

    const setNewDataAdr = (newData) => {
      state.newDataAdr = newData;
    }

    const setNewAdresse = (newAdresse) => {
      state.newAdresse = newAdresse
    }

    const setNewDataObjo = (newData) => {
      state.newDataObjo = newData;
    }

    const setNewObjo = (newObjo) => {
      state.newObjo = newObjo
    }

    const cancelModifs = () => {
      state.editData = false;
      state.addAdresseObjo = false;
      state.newData = state.infoDatas;
      state.renderInfos = state.renderInfos + 1;
      reloadData();
    }

    const updateData = async() => {
      const newData = [] as any;
      if(state.lienMenu != 3 && state.lienMenu != 4){
        for (const [key, value] of Object.entries(state.newData)) {
          if (value != (state.infoDatas as any)[key]) newData.push({champ: key, value: value});
        }
        await mAxiosApi.post("/updateUserInfos", {data: newData});
      }

      if(state.lienMenu == 3 && !state.addAdresseObjo){
        await mAxiosApi.post("/addUpdateAdresses", {data: state.newDataAdr});
      }else if(state.lienMenu == 3 && state.addAdresseObjo){
        await mAxiosApi.post("/addUpdateAdresses", {data: [state.newAdresse]});
      }

      if (state.lienMenu == 4 && !state.addAdresseObjo) {
        await mAxiosApi.post("/addUpdateObjectifs", {data: state.newDataObjo});
      }else if(state.lienMenu == 4 && state.addAdresseObjo){
        await mAxiosApi.post("/addUpdateObjectifs", {data: [state.newObjo]});
      }

      reloadData();
      ElNotification({
        title: 'Succès',
        message: 'Données modifiées avec succès !',
        type: 'success',
        duration: 3000
      })
      state.editData = false;
      state.addAdresseObjo = false;
    }

    onMounted(async () => {

      checkRoot()
      if (router.currentRoute.value.params.mail) {
        await mAxiosApi.prototype.getAxios("/setUserID/" + router.currentRoute.value.params.mail);
        //router.push({ name: "sign-in" });
        //return false;
      }    
      
      const permission = await mAxiosApi.prototype.getAxios("/getFolderPerm");
      state.permission = permission.results;
      await reloadData();

      state.loading = false;
    });

    return {
      state,
      tabs,
      objoMensuel,
      millier,
      goto,
      reloadData,
      updateData,
      cancelModifs,
      setNewData,
      setNewAdresse,
      setNewDataAdr,
      setNewDataObjo,
      setNewObjo,
    }
  }
});
</script>
